import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { GameController } from '@phosphor-icons/react';

export const NavBar = ({ onGetStarted }) => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#E4E4E7]">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-[#0047FF] p-2">
            <GameController size={28} weight="fill" color="#FFFFFF" />
          </div>
          <span className="font-heading text-xl font-bold tracking-tight text-[#09090B]">
            DashLink Gaming
          </span>
        </div>
        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-sm text-[#71717A] hover:text-[#09090B] transition-colors">Features</a>
          <a href="#demo" className="text-sm text-[#71717A] hover:text-[#09090B] transition-colors">Demo</a>
          <a href="#testimonials" className="text-sm text-[#71717A] hover:text-[#09090B] transition-colors">Stories</a>
          <a href="#contact" className="text-sm text-[#71717A] hover:text-[#09090B] transition-colors">Contact</a>
          <Link to="/guides" className="text-sm text-[#71717A] hover:text-[#09090B] transition-colors" data-testid="nav-guides-link">Guides</Link>
          <Link to="/about" className="text-sm text-[#71717A] hover:text-[#09090B] transition-colors" data-testid="nav-about-link">About</Link>
        </div>
        <Button 
          onClick={onGetStarted}
          className="bg-[#0047FF] hover:bg-[#0037CC] text-white"
          data-testid="nav-get-started"
        >
          Launch App
        </Button>
      </div>
    </nav>
  );
};
